export type PushOptInEntryPoint =
  | 'onboarding'
  | 'main_shell'
  | 'login'
  | 'notifications_banner';

export type PushPermissionReceive = 'prompt' | 'granted' | 'denied' | 'prompt-with-rationale';

export function normalizePushPermissionReceive(
  receive: string
): PushPermissionReceive {
  if (receive === 'granted' || receive === 'denied') return receive;
  if (receive === 'prompt-with-rationale') return 'prompt';
  return 'prompt';
}

export const PUSH_MAIN_SHELL_PROMPTED_KEY = 'gt push_main_shell_prompted_v1';

/** User dismissed the soft sheet (Not now / close); auto-prompts stop, banner remains. */
export const PUSH_SHEET_DISMISSED_KEY = 'gt_push_sheet_dismissed_v1';

export function getPushPermissionBannerMessage(receive: PushPermissionReceive): string {
  switch (receive) {
    case 'denied':
      return 'Notifications are disabled. Enable them in device settings to stay updated on travel offers and activities.';
    case 'prompt':
      return 'Enable notifications to receive updates about your travel recommendations and offers.';
    default:
      return '';
  }
}

export function shouldShowPushOptInSheet(
  receive: PushPermissionReceive,
  sheetAlreadyVisible: boolean,
  sheetDismissed: boolean
): boolean {
  return receive === 'prompt' && !sheetAlreadyVisible && !sheetDismissed;
}
